<template>
    <div v-if="VisibleActions.length > 0"
         class="btn-group btn-group-action"
         role="group"
         aria-label="Default action">

        <button v-for="(action, index) in VisibleActions"
                :key="index"
                type="button"
                class="btn"
                :class="action.className"
                data-toggle="tooltip"
                data-placement="top"
                :title="action.title"
                @click.prevent="callMethod('',action)">
            <div v-if="action.className != 'change-state'">
                <app-icon v-if="action.icon" :name="action.icon"/>
                <span v-else>
                    {{ action.title }}
                </span>
            </div>

        </button>
        <div v-for="(action, index) in VisibleActions">
            <div v-if="action.className == 'change-state'" style="width: 170px">
                <app-input  class="col-sm-12 mb-5 pl-0 pr-0"
                            type="select"
                            v-model="timeline"
                            :list="timelineState"
                            :required="false"
                            @change="action.timeline = timeline;callMethod('',action)"/>

            </div>
        </div>

    </div>
</template>

<script>
import {ActionMixin} from "./mixin/ActionMixin.js";

export default {
    name: "DefaultAction",
    mixins: [ActionMixin],
    props: {
        timelineState: Array,
        timelineSelectedState: [Number, String],
    },
    mounted() {
        setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip()
        }, 500);

    },
    data() {
        return {
            timeline: this.timelineSelectedState,
            sourceLists: [
                {id: '1', value: 'Pracovní portály'},
                {id: '2', value: 'Personální agentura'},
                {id: '3', value: 'E-mail a telefon'},
                {id: '4', value: 'Kariérní stránka'},
                {id: '5', value: 'LinkedIn'},
                {id: '6', value: 'Facebook'},
                {id: '7', value: 'Twitter'},
                {id: '8', value: 'Venkovní reklama'},
                {id: '9', value: 'Jiné'},
            ],
            inputs: {
                source: '1',
                timeline_state: this.timelineSelectedState,
            },
        }
    }
}
</script>
